import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { UserDetailsService } from "app/core/services/user-details.service";

@UntilDestroy()
@Directive({
    selector: "[hasNotPermissions]",
})
export class HasNotPermissionsDirective implements OnInit {
    private notPermissions: string[] = [];

    constructor(
        private userDetailsService: UserDetailsService,
        private viewContainerRef: ViewContainerRef,
        private templateRef: TemplateRef<any>
    ) {}

    @Input()
    set hasNotPermissions(permissions: string | string[]) {
        this.notPermissions = this.notPermissions.concat(permissions);
    }

    ngOnInit(): void {
        this.userDetailsService.user$.pipe(untilDestroyed(this)).subscribe(() => {
            this.execute();
        });
    }

    private execute(): void {
        if (!this.userDetailsService.hasAnyPermission(...this.notPermissions)) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainerRef.clear();
        }
    }
}
